export function readDesktopChartTheme() {
  if (typeof window === "undefined") {
    return {
      accent:          "#0EC4B4",
      background:      "#080D17",
      border:          "rgba(255,255,255,0.10)",
      textPrimary:     "#E4EAF4",
      textSecondary:   "#8FA8C8",
      textMuted:       "#607A99",
      bullish:         "#16B85A",
      bearish:         "#F04545",
      elevated:        "#121A2B",
      overlay:         "#182235",
      chartGrid:       "rgba(255,255,255,0.04)",
      chartAreaFill:   "rgba(14,196,180,0.10)",
      chartAreaStroke: "rgba(14,196,180,0.50)",
    };
  }

  const styles = window.getComputedStyle(document.documentElement);

  return {
    accent:          styles.getPropertyValue("--accent-primary").trim()    || "#0EC4B4",
    background:      styles.getPropertyValue("--bg-base").trim()           || "#080D17",
    border:          styles.getPropertyValue("--border-default").trim()    || "rgba(255,255,255,0.10)",
    textPrimary:     styles.getPropertyValue("--text-primary").trim()      || "#E4EAF4",
    textSecondary:   styles.getPropertyValue("--text-secondary").trim()    || "#8FA8C8",
    textMuted:       styles.getPropertyValue("--text-muted").trim()        || "#607A99",
    bullish:         styles.getPropertyValue("--bullish").trim()           || "#16B85A",
    bearish:         styles.getPropertyValue("--bearish").trim()           || "#F04545",
    elevated:        styles.getPropertyValue("--bg-elevated").trim()       || "#121A2B",
    overlay:         styles.getPropertyValue("--bg-overlay").trim()        || "#182235",
    chartGrid:       styles.getPropertyValue("--chart-grid").trim()        || "rgba(255,255,255,0.04)",
    chartAreaFill:   styles.getPropertyValue("--chart-area-fill").trim()   || "rgba(14,196,180,0.10)",
    chartAreaStroke: styles.getPropertyValue("--chart-area-stroke").trim() || "rgba(14,196,180,0.50)",
  };
}
